// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/finalize_color_preset.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ColorPreset } from "./color_preset_pb";
import { file_vision_assets_v1_color_preset } from "./color_preset_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/finalize_color_preset.proto.
 */
export const file_vision_assets_v1_finalize_color_preset: GenFile = /*@__PURE__*/
  fileDesc("Cix2aXNpb24vYXNzZXRzL3YxL2ZpbmFsaXplX2NvbG9yX3ByZXNldC5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEirAEKGkZpbmFsaXplQ29sb3JQcmVzZXRSZXF1ZXN0EkoKBnBhcmFtcxgBIAEoCzI6LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkZpbmFsaXplQ29sb3JQcmVzZXRSZXF1ZXN0LlBhcmFtcxIYChBjbGllbnRfdXBsb2FkX2lkGAIgASgJGigKBlBhcmFtcxIQCghhc3NldF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJIqoBChtGaW5hbGl6ZUNvbG9yUHJlc2V0UmVzcG9uc2USSwoGcmVzdWx0GAEgASgLMjsucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuRmluYWxpemVDb2xvclByZXNldFJlc3BvbnNlLlJlc3VsdBo+CgZSZXN1bHQSNAoGcHJlc2V0GAEgASgLMiQucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuQ29sb3JQcmVzZXRiBnByb3RvMw", [file_vision_assets_v1_color_preset]);

/**
 * @generated from message protos.vision.assets.v1.FinalizeColorPresetRequest
 */
export type FinalizeColorPresetRequest = Message<"protos.vision.assets.v1.FinalizeColorPresetRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.FinalizeColorPresetRequest.Params params = 1;
   */
  params?: FinalizeColorPresetRequest_Params | undefined;

  /**
   * @generated from field: string client_upload_id = 2;
   */
  clientUploadId: string;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeColorPresetRequest.
 * Use `create(FinalizeColorPresetRequestSchema)` to create a new message.
 */
export const FinalizeColorPresetRequestSchema: GenMessage<FinalizeColorPresetRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_color_preset, 0);

/**
 * @generated from message protos.vision.assets.v1.FinalizeColorPresetRequest.Params
 */
export type FinalizeColorPresetRequest_Params = Message<"protos.vision.assets.v1.FinalizeColorPresetRequest.Params"> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeColorPresetRequest.Params.
 * Use `create(FinalizeColorPresetRequest_ParamsSchema)` to create a new message.
 */
export const FinalizeColorPresetRequest_ParamsSchema: GenMessage<FinalizeColorPresetRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_color_preset, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.FinalizeColorPresetResponse
 */
export type FinalizeColorPresetResponse = Message<"protos.vision.assets.v1.FinalizeColorPresetResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.FinalizeColorPresetResponse.Result result = 1;
   */
  result?: FinalizeColorPresetResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeColorPresetResponse.
 * Use `create(FinalizeColorPresetResponseSchema)` to create a new message.
 */
export const FinalizeColorPresetResponseSchema: GenMessage<FinalizeColorPresetResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_color_preset, 1);

/**
 * @generated from message protos.vision.assets.v1.FinalizeColorPresetResponse.Result
 */
export type FinalizeColorPresetResponse_Result = Message<"protos.vision.assets.v1.FinalizeColorPresetResponse.Result"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ColorPreset preset = 1;
   */
  preset?: ColorPreset | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeColorPresetResponse.Result.
 * Use `create(FinalizeColorPresetResponse_ResultSchema)` to create a new message.
 */
export const FinalizeColorPresetResponse_ResultSchema: GenMessage<FinalizeColorPresetResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_color_preset, 1, 0);

